<div
    class="d-flex w-100 mb-4 align-items-center sc-supergroup-filter"
    *ngIf="superGroups?.length !== 0"
>
    <div class="d-flex align-self-end h-100">
        <h5 class="text-left text-nowrap">
            {{ _i18n._9294_SHOW_HIDE_SUPERGROUPS | translate }}
        </h5>
    </div>
    <cmps-slide-bar class="chart-slide-bar">
        <ng-container *ngFor="let p of superGroups">
            <div
                class="d-inline-block m-1"
                [cmpsTooltipTrigger]="p.name === p.fullName ? null : p.fullName"
                trigger="hover"
            >
                <button
                    cmpsEyeToggleButton
                    class="sc-supergroup-filter--button d-flex"
                    [class.sc-supergroup-filter--button--selected]="
                        p.isSelected
                    "
                    [class.sc-supergroup-filter--button--deSelected]="
                        !p.isSelected
                    "
                    (click)="_onSelectionChange(p)"
                    [disabled]="!p.canBeDeselected"
                    [selected]="p.isSelected"
                    [style.background]="p.isSelected ? p.colour : '#fff'"
                    [style.borderColor]="p.colour"
                >
                    <span
                        cmpsEyeToggleButtonLabel
                        [style.color]="p.isSelected ? '#fff' : '#505050'"
                    >
                        {{ p.name }}
                    </span>
                </button>
            </div>
        </ng-container>
    </cmps-slide-bar>
</div>
